import ActionCard from "src/components/ActionCard";
import DatePicker from "src/components/DatePicker";
import Select from "src/components/Select";
import NumberInput from "src/components/NumberInput/NumberInput";
import { ExpirationMode, Unit } from "src/generated/graphql";
import { UseFormReturnType } from "@mantine/form";
import SegmentedControl from "src/components/SegmentedControl";

interface ExpirationFieldProps<T> {
  form: UseFormReturnType<T>;
  isActive?: boolean;
}

export const ExpirationFields = <T,>({
  form,
  isActive = false,
}: ExpirationFieldProps<T>) => {
  const { value: expiredValue, ...expirationProps } =
    form.getInputProps("mode");
  return (
    <ActionCard
      title="Expiration"
      hideChild={expiredValue === ExpirationMode.Never ? true : false}
      rightIconButton={
        <SegmentedControl
          data={[
            ExpirationMode.Never,
            ExpirationMode.Date,
            ExpirationMode.Duration,
          ]}
          value={expiredValue}
          {...expirationProps}
          disabled={isActive}
        />
      }
    >
      {expiredValue === ExpirationMode.Date && (
        <DatePicker
          label="Date of Expiration"
          dropdownPosition="top-start"
          disabled={isActive}
          {...form.getInputProps("expiresAt")}
        />
      )}
      {expiredValue === ExpirationMode.Duration && (
        <>
          <Select
            disabled={isActive}
            data={Object.keys(Unit)}
            label="Unit"
            {...form.getInputProps("expirationUnit")}
          />
          <NumberInput
            disabled={isActive}
            label="Value"
            {...form.getInputProps("expirationValue")}
          />
        </>
      )}
    </ActionCard>
  );
};
